<template>
  <div>
    <CCard>
      <CCardHeader>
        <CCardTitle
                style="
                  display: inline-block;
                  margin-top: 8px;
                  margin-bottom: 0px;
                "
                ><h3>{{ $i18n.t("licitadores.detalles")}} {{licitador.nombre}}</h3></CCardTitle
              >
        <b></b>
        <CButton
                style="
                  display: inline-block;
                  float:right;
                  margin-top: 8px;
                  margin-bottom: 8px;
                "
                color="secondary"
                @click="returnPage"
                >Volver</CButton
              >
      </CCardHeader>
      <CCardBody>
        <CRow form class="form-group">
          <CCol sm="12">
            <CInput
              label="Nombre del licitador"
              type="text"
              disabled
              v-model="licitador.nombre"
              @change="handleNombreLicitador"
              horizontal
            />
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol sm="12">
            <CInput
              label="DNI / CIF"
              disabled
              type="text"
              v-model="licitador.dnicif"
              @change="handleDNICIF"
              horizontal
            />
          </CCol>
        </CRow>
        <CRow form class="form-group">
          <CCol sm="3">
            <b>Solvencia técnica</b>
          </CCol>
          <CCol sm="9" v-if="licitador.solvencia && licitador.solvencia.length > 0">
            <CDataTable
            hover
            striped
          :items-per-page="5"
            :items="licitador.solvencia"
            :fields="camposSolvencia"
            sorter
            pagination
          >
          </CDataTable>
          </CCol>
          <CCol sm="9" v-if="licitador.solvencia && licitador.solvencia.length == 0">
            Sin registros
          </CCol>
        </CRow>
        
        <CRow form class="form-group">
          <CCol sm="3">
            <b>Situación</b>
          </CCol>
          <CCol sm="9" v-if="licitador.situacion && licitador.situacion.length > 0">
            <CDataTable
            hover
            striped
          :items-per-page="5"
            :items="licitador.situacion"
            :fields="camposSituacion"
            sorter
            pagination
          >
          </CDataTable>
          </CCol>
          <CCol sm="9" v-if="licitador.situacion && licitador.situacion.length == 0">
            Sin registros
          </CCol>
        </CRow>

        <CRow form class="form-group">
          <CCol
            sm="12"
            class="d-flex justify-content-between align-items-center"
          >
            <b>Lotes ofertados</b>
            <div>  
              <CButton
                color="info"
                style="display: inline-block"
                @click="showFiltrosCampo = true"
                >Filtrar columnas</CButton
              >
              <CustomExport
                style="display: inline-block"
                :lista="licitador.ofertas"
                :fields="camposOferta"
                :name="licitador.nombre + ' - Ofertas'"
              ></CustomExport>
            </div>
          </CCol>
          <CCol sm="12">
          <CDataTable
            v-if="licitador.ofertas && licitador.ofertas.length > 0"
            hover
            :tableFilter="{ placeholder: 'Introducir valor', label: 'Buscar' }"
            :itemsPerPageSelect="{
              label: 'Elementos por página',
              values: [5, 10, 15, 20, 25],
            }"
            striped
            :items-per-page="5"
            :items="licitador.ofertas"
            :fields="camposOfertaFiltrados"
            sorter
            :pagination-change="setColorPrimerPuesto"
            :page-change="setColorPrimerPuesto"
            column-filter
            pagination
          >
            <template #puestoConcurso="{ item, index }">
              <td>
                <CBadge
                  style="font-size: 17px; margin-top: 10px"
                  :color="getBadgePosicion(item.puestoConcurso)"
                  >{{ item.puestoConcurso }}</CBadge
                >
              </td>
            </template>
            <template #acciones="{ item }">
            <td>
              <CButton @click="seleccionarOfertaDetalles(item)" color="info"
                >Información</CButton
              >
            </td>
          </template>
            <template #descripcionEstadoLoteOfertado="{ item }">
              <td>
                <CBadge :color="getBadge(item.descripcionEstadoLoteOfertado)">{{
                  item.descripcionEstadoLoteOfertado
                }}</CBadge>
              </td>
            </template>
            <template #estadoLote="{ item }">
              <td>
                <CBadge :color="getBadgeEstado(item.estadoLote)">{{
                  item.estadoLote
                }}</CBadge>
              </td>
            </template>
            <template #precioDiaSinIVA="{ item }">
              <td>
                {{ item.precioDiaSinIVA ? item.precioDiaSinIVA : 0 }}                
              </td>
            </template>
            <template #descripcionEmision="{ item }">
              <td>
                {{ item.descripcionEmision ? item.descripcionEmision : "-" }}
              </td>
            </template>
            <template #distanciaCentroTrabajo="{ item }">
              <td>
                {{
                  item.distanciaCentroTrabajo
                    ? item.distanciaCentroTrabajo
                    : "-"
                }}
              </td>
            </template>
            <template #distanciaTallerCochera="{ item }">
              <td>
                {{
                  item.distanciaTallerCochera
                    ? item.distanciaTallerCochera
                    : "-"
                }}
              </td>
            </template>
            <template #accesibilidad="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.accesibilidad)">
                  {{ item.accesibilidad ? item.accesibilidad : "-" }}
                </CBadge>
              </td>
            </template>
            <template #cumpleUNE26494="{ item }">
            <td>
              <CBadge :color="getBadgeValores(item.cumpleUNE26494)">
                {{ item.cumpleUNE26494 ? item.cumpleUNE26494 : "-" }}
              </CBadge>
            </td>
          </template>
            <template #estabilidadLaboral="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.estabilidadLaboral)">
                  {{ item.estabilidadLaboral ? item.estabilidadLaboral : "-" }}
                </CBadge>
              </td>
            </template>
            <template #vehiculoDisponible="{ item }">
              <td>
                <CBadge :color="getBadgeValores(item.vehiculoDisponible)">
                  {{ item.vehiculoDisponible ? item.vehiculoDisponible : "-" }}
                </CBadge>
              </td>
            </template>
            <template #baja="{ item }">
              <td>
                <CBadge :color="getBadgeBajaExcluido(item.baja)">
                  {{ item.baja ? item.baja : "-" }}
                </CBadge>
              </td>
            </template>
            <template #excluido="{ item }">
              <td>
                <CBadge :color="getBadgeBajaExcluido(item.excluido)">
                  {{ item.excluido ? item.excluido : "-" }}
                </CBadge>
              </td>
            </template>
          </CDataTable>
          </CCol>
          <CCol sm="12"
            v-if="licitador.ofertas && licitador.ofertas.length == 0"
          >
            Sin ofertas
          </CCol>
          </CRow>
        
      </CCardBody>
    </CCard>

    <CModal
      title="Filtrar columnas de la tabla"
      :show.sync="showFiltrosCampo"
      size="lg"
      centered
    >
      <CRow>
        <CCol
          v-for="(campo, index) in camposOferta"
          :key="index"
          sm="6"
          v-if="campo.label != 'Seleccionar'"
          ><CInputCheckbox
            :label="campo.label"
            :checked="camposOfertaFiltrados.indexOf(campo) > -1"
            @change="setFiltroCampoValue(campo)"
        /></CCol>
      </CRow>

      <template #footer>
        <CButton @click="showFiltrosCampo = false" color="info"
          >Aceptar</CButton
        >
      </template>
    </CModal>

    <CModal
      v-if="ofertaSeleccionada"
      title="Información de la oferta"
      :show.sync="showInformacionOferta"
      size="lg"
      centered
    >
      <CRow v-if="ofertaSeleccionada">
        <CCol
          v-for="(campo, index) in camposOferta"
          :key="index"
          sm="6"
          v-if="campo.key != 'acciones'"
        >
          <CRow>
            <CCol sm="6"
              ><b>{{ campo.label }}</b></CCol
            >
            <CCol sm="6">{{
              ofertaSeleccionada[campo.key] != null
                ? ofertaSeleccionada[campo.key]
                : "-"
            }}</CCol>
          </CRow>
        </CCol>
      </CRow>
      <CRow v-if="ofertaSeleccionada" class="puntos-row">
        <CCol>
          <h5 v-if="ofertaSeleccionada.detallePuntos.length > 0" class="puntos-title">Puntuación obtenida</h5>
          <h5 v-if="ofertaSeleccionada.detallePuntos.length == 0" class="puntos-title">Todavía no se han calculado los puntos</h5>
        </CCol>
      </CRow>
      <CRow v-if="ofertaSeleccionada && ofertaSeleccionada.detallePuntos.length > 0">
        <CCol>
          <CRow>
            <CCol sm="12"
              ><b>
                <CDataTable
                  hover
                  striped
                  :items-per-page="10"
                  :items="ofertaSeleccionada.detallePuntos"
                  :fields="camposPuntos"
                  pagination
                >
                </CDataTable> </b
            ></CCol>
          </CRow>
        </CCol>
      </CRow>

      <template #footer>
        <CButton
          @click="verConcurso(ofertaSeleccionada.idConcurso)"
          color="info"
          >Ir al concurso</CButton
        >
        <CButton
          @click="verDetallesLote(ofertaSeleccionada.idLote)"
          color="info"
          >Ir al lote</CButton
        >
        <CButton @click="showInformacionOferta = false" color="info"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<style scoped>
.puntos-title {
  color: rgb(48, 99, 146);
}

.puntos-row {
  margin-top: 30px;
  margin-bottom: 10px;
}
</style>

<script>
import Cookies from "js-cookie";
import { logOut } from "../../utils/authUtils";
import { getDetallesLicitador } from '../../requests/licitadores'
import { getDetallesOferta } from "../../requests/ofertas";
import CustomExport from "../../utils/CustomExport";

export default {
  name: "NuevoLicitador",
  components: {
    CustomExport
  },
  created() {

  },
  mounted(){
    this.idLicitador = this.$route.query.id;
    this.camposOfertaFiltrados = Array.from(this.camposOferta);

    getDetallesLicitador(this.idLicitador).then(res => {
      this.licitador = res.data;
      this.handleLotesOfertados(this.licitador.ofertas);
      //console.log(this.licitador)
    }).catch((error) => {
        if (error.response.status == 403 || error.response.status == 401) logOut(this.$router);
      });
  },
  data() {
    return {
      idLicitador: 0,
      licitador: {},
      ofertaSeleccionada: null, 
      camposSolvencia: [
        { key: "nombreConcurso", field: "Concurso", label: "Concurso" },
        { key: "numeroLotesOfertados", field: "Lotes ofertados", label: "Lotes ofertados" },
        { key: "numeroVehiculosOfertados", field: "Vehículos ofertados", label: "Vehículos ofertados" },
        { key: "numeroConductoresOfertados", field: "Conductores ofertados", label: "Conductores ofertados" },
      ],
      camposSituacion: [
        { key: "nombreConcurso", field: "Concurso", label: "Concurso" },
        { key: "situacion", field: "Situacion", label: "Situacion" },
      ],
      camposPuntos: [
        {
          key: "nombreCriterio",
          field: "Criterio de evaluación",
          label: "Criterio de evaluación",
        },
        {
          key: "puntosObtenidos",
          field: "Puntos obtenidos",
          label: "Puntos obtenidos",
        },
      ],
      showFiltrosCampo: false,
      showInformacionOferta: false,
      camposOfertaFiltrados: [], //campos seleccionados para la tabla de ofertas
      camposOferta: [
        { key: "acciones", field: "Seleccionar", label: "Seleccionar" },
        { key: "nombreConcurso", field: "Concurso", label: "Concurso" },
        { key: "numeroExpedienteConcurso", field: "Expediente", label: "Expediente" },
        { key: "numeroLote", field: "Lote", label: "Lote" },
        { key: "estadoLote", field: "Estado Lote", label: "Estado Lote" },
        { key: "puestoConcurso", field: "Puesto", label: "Puesto" },
        { key: "puntos", field: "Puntos", label: "Puntos" },       
        { key: "baja", field: "Baja", label: "Baja" },
        { key: "excluido", field: "Excluido", label: "Excluido" },
        { key: "motivoExlusion", field: "Motivo Exclusion", label: "Motivo Exclusion" },
        {
          key: "ordenPreferencia",
          field: "Orden Preferencia",
          label: "Orden Preferencia",
        },
        { key: "nombreLicitador", field: "Nombre", label: "Nombre" },
        { key: "dnicifLicitador", field: "DNI / CIF", label: "DNI / CIF" },
        { key: "descripcionEstadoLoteOfertado", field: "Estado", label: "Estado" },
        {
          key: "precioDiaSinIVA",
          field: "Precio dia",
          label: "Precio dia",
        },
        {
          key: "plazasTotales",
          field: "Plazas totales",
          label: "Plazas totales",
        },
        {
          key: "descripcionAntiguedad",
          field: "Antiguedad",
          label: "Antiguedad",
        },
        {
          key: "descripcionEmision",
          field: "Emisiones",
          label: "Emisiones",
        },
        {
          key: "estabilidadLaboral",
          field: "Estabilidad laboral",
          label: "Estabilidad laboral",
        },
        {
          key: "accesibilidad",
          field: "Accesibilidad",
          label: "Accesibilidad",
        },
        {
          key: "cumpleUNE26494",
          field: "Acredita oficialmente adaptación",
          label: "Acredita oficialmente adaptación",
        },
         //{
        //  key: "vehiculoDisponible",
        //  field: "Disponibilidad vehículo",
        //  label: "Disponibilidad vehículo",
        //},
        {
          key: "descripcionContinuidad",
          field: "Compromiso Continuidad",
          label: "Compromiso Continuidad",
        }
        /*
        {
          key: "distanciaTallerCochera",
          field: "Distancia del taller a la cochera",
          label: "Distancia del taller a la cochera",
        },*/
      ],
    };
  },
  methods: {
    returnPage() {
      this.$router.back();
    },
    handleNombreLicitador(){

    },
    handleDNICIF(){

    },
    handleEstado(){

    },
    getBadgePosicion(idEstado) {
      switch (idEstado) {
        case 1:
          return "success";
        case 2:
          return "info";
        case 3:
          return "info";
        default:
          return "secondary";
      }
    },
     getBadge(situacion) {
      // console.log(situacion);
      switch (situacion) {
        case "Sin Asignar":
          return "danger";
        case "Asignado Pendiente Validar":
          return "info";
        case "Asignado Pendiente Desempate":
          return "warning";
        case "Asignado Validado":
          return "success";
        case "Adjudicado":
          return "success";
        case "Asignado Pendiente Subsanación":
          return "warning";
        default:
          return "warning";
      }
    },
    getBadgeEstado(situacion) {
      switch (situacion) {
        case "Sin Asignar":
          return "danger";
        case "Asignado Pendiente Validar":
          return "info";
        case "Asignado Pendiente Desempate":
          return "warning";
        case "Asignado Validado":
          return "success";
        case "Adjudicado":
          return "success";
        case "Asignado Pendiente Subsanación":
          return "warning";
        case "Desistido o renunciado":
          return "danger";
        case "Desierto":
          return "danger";
        default:
          return "warning";
      }
    },
    getBadgeValores(valor) {
      switch (valor) {
        case "Si":
          return "success";
        case "No":
          return "danger";
        default:
          return "";
      }
    },
    getBadgeBajaExcluido(valor) {
      switch (valor) {
        case "Si":
          return "danger";
        case "No":
          return "success";
        case "Justificada":
          return "success";
        case "No Justificada":
          return "danger";
        default:
          return "secondary";
      }
    },
    seleccionarOfertaDetalles(oferta) {
      let idOferta = oferta.id;
      getDetallesOferta(idOferta).then((res) => {
        this.handleOfertaIndividual(res.data);
        this.ofertaSeleccionada = res.data;
        this.showInformacionOferta = true;
      });
    },
    verDetallesLote(idLote) {
      this.$router.push({ path: "/lotes/detalle?id=" + idLote }); //a los detalles del lote
    },
    verConcurso(idConcurso) {
      this.$router.push({ path: "/concursos/detalle?id=" + idConcurso }); //a los detalles del concurso
    },
    handleLotesOfertados(ofertas) {
      //console.log(ofertas)
      //modifica algunos campos de las ofertas
      ofertas.forEach((lote) => {
        lote.puestoConcurso = lote.puestoConcurso
          ? lote.puestoConcurso
          : "Sin calcular";
        lote.numeroExpedienteConcurso = lote.numeroExpedienteConcurso + " " + lote.nombreSubexpediente;
        lote.excluido = lote.excluido == 0 ? "No" : "Si";
        lote.motivoExlusion = lote.motivoExlusion ? lote.motivoExlusion : "-";
        lote.accesibilidad = lote.accesibilidad == 0 ? "No" : "Si";
        lote.cumpleUNE26494 = lote.cumpleUNE26494 == null ? "" : (lote.cumpleUNE26494 == 0 ? "No" : "Si");
        lote.vehiculoDisponible = lote.vehiculoDisponible == 0 ? "No" : "Si";
        lote.descripcionContinuidad = lote.descripcionContinuidad ? lote.descripcionContinuidad : "-";
        if(lote.estabilidadLaboral==null)
        {lote.estabilidadLaboral="-";}else{lote.estabilidadLaboral = lote.estabilidadLaboral == 0 ? "No" : "Si";}
        lote.plazasTotales = lote.plazasTotales ? lote.plazasTotales : "-";
        lote.puntos=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(lote.puntos);
        lote.precioDiaSinIVA=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(lote.precioDiaSinIVA)+" €";
         
        
      });
    },
    handleOfertaIndividual(lote){
      lote.puestoConcurso = lote.puestoConcurso
          ? lote.puestoConcurso
          : "Sin calcular";
        lote.numeroExpedienteConcurso = lote.numeroExpedienteConcurso + " " + lote.nombreSubexpediente;
        lote.excluido = lote.excluido == 0 ? "No" : "Si";
        lote.accesibilidad = lote.accesibilidad == 0 ? "No" : "Si";
        lote.cumpleUNE26494 = lote.cumpleUNE26494 == null ? "" : (lote.cumpleUNE26494 == 0 ? "No" : "Si");
        lote.vehiculoDisponible = lote.vehiculoDisponible == 0 ? "No" : "Si";
        lote.descripcionContinuidad = lote.descripcionContinuidad ? lote.descripcionContinuidad : "-";
        if(lote.estabilidadLaboral==null)
        {lote.estabilidadLaboral="-";}else{lote.estabilidadLaboral = lote.estabilidadLaboral == 0 ? "No" : "Si";}
        lote.plazasTotales = lote.plazasTotales ? lote.plazasTotales : "-";
        lote.puntos=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(lote.puntos);
        lote.precioDiaSinIVA=Intl.NumberFormat("es-ES",{minimumFractionDigits: 0,maximumFractionDigits: 2}).format(lote.precioDiaSinIVA)+" €";
       
    },
    setFiltroCampoValue(campo) {
      //añade o elimina campos de la tabla de las ofertas
      if (this.camposOfertaFiltrados.indexOf(campo) > -1) {
        this.camposOfertaFiltrados.splice(
          this.camposOfertaFiltrados.indexOf(campo),
          1
        );
      } else this.camposOfertaFiltrados.push(campo);
    },
    setColorPrimerPuesto() {
      //colorea las filas de los primeros puestos
      let rows = document.getElementsByClassName("primera");
      rows.forEach((row) => {
        //console.log(row.parentElement.parentElement);
        row.parentElement.parentElement.classList.add("primer-puesto");
      });
    },
  },
  beforeDestroy() {

  },
};
</script>
